module.exports = __webpack_public_path__ + "static/media/anaLogyImg.2d26bb5f.svg";